import apiApp from "@/utils/callApp";
// 语言匹配规则
// cn 简体中文 包含zh但不包含zh-Hant
// tw 繁体台湾 包含zh-Hant
// kr 韩语
// const langs ={
//     'zh':'cn',
//     'zh-Hant':'tw',
//     'en':'en',
//     'kr':'kr'
// }
export default {
  data() {
    return {
      lan: "",
      token: ""
    };
  },
  mounted() {
    // 获取语言是否从app端获取语言 是用app端获取的语言，不是缓存中有语言了用缓存中的语言，
    if (this.$route.query.lan) {
      const lan = this.$route.query.lan;
      let cnReg = /^zh(?!-Hant)/;
      let twReg = /^zh-Hant/;
      let krReg = /kr/;
      let lang = "";
      if (cnReg.test(lan)) {
        lang = "cn";
      } else if (twReg.test(lan)) {
        lang = "tw";
      } else if (krReg.test(lan)) {
        lang = "kr";
      } else {
        lang = "en";
      }
      // const lang = langs[lan]?langs[lan]:'en'
      this.lan = lang;
      localStorage.setItem("lang", lang);
      this.$i18n.locale = lang;
    }
    // 获取token
    window.setToken = this.setToken;
    this.appToken();
    if (process.env.NODE_ENV == "development") {
      this.token = "cs";
    }
  },
  methods: {
    appToken() {
      var req = { params: {}, callbackfunc: "setToken" };
      apiApp.callApp("Native", "getToken", req);
    },
    setToken(res) {
      this.token = res;
      localStorage.setItem("token", res);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/entrance.js